import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  {
    name: "WSafe AI",
    pill: "Step 1 · Detect",
    line: "AI hazard detection on existing cameras.",
    domain: "wsafe.ai",
    icon: "/brand/products/wsafe-ai-icon.svg",
  },
  {
    name: "EnviSafe",
    pill: "Step 1 · Detect",
    line: "Environmental conditions monitoring.",
    domain: "envisafe.ai",
    icon: "/brand/products/envisafe-icon.svg",
  },
  {
    name: "SafeForm",
    pill: "Step 1 · Detect",
    line: "Ergonomic analysis.",
    domain: "safeform.ai",
    icon: "/brand/products/safeform-icon.svg",
  },
  {
    name: "InductIQ",
    pill: "Step 2 · Triage",
    line: "Induction/training verification and incident reporting.",
    domain: "inductiq.ai",
    icon: "/brand/products/inductiq-icon.svg",
  },
  {
    name: "HazardLoop",
    pill: "Step 2–3 · Act & close",
    line: "Corrective action tracking and verified closeout.",
    domain: "hazardloop.com",
    icon: "/brand/products/hazardloop-icon.svg",
  },
  {
    name: "WorkSafeStory",
    pill: "Step 3 · Learn",
    line: "Safety stories and lessons learned.",
    domain: "worksafestory.com",
    icon: "/brand/products/worksafestory-icon.svg",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="bg-wash py-[88px] scroll-mt-16">
      <div className="mx-auto max-w-[1160px] px-6">
        <Chapter
          eyebrow="The suite"
          title="Six products, one system."
          lede="Each one hands its output to the next step in the loop."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.name} delay={(i % 3) * 0.1} className="h-full">
              <div
                data-testid={`product-card-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                className="h-full bg-white border border-line border-t-[3px] border-t-safety rounded-[14px] p-8 shadow-[0_2px_10px_rgba(23,71,95,0.05)] flex flex-col"
              >
                <img src={p.icon} alt={`${p.name} icon`} className="w-10 h-10 mb-6" loading="lazy" />
                <h3 className="text-xl font-extrabold text-navy mb-2">{p.name}</h3>
                <span className="inline-block self-start text-[11px] font-bold uppercase tracking-[0.15em] text-navy bg-wash border border-line rounded-full px-3 py-1 mb-4">
                  {p.pill}
                </span>
                <p className="text-sm text-steel leading-relaxed mb-6 flex-1">{p.line}</p>
                <a
                  href={`https://${p.domain}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`product-link-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                  className="inline-flex items-center gap-1.5 text-sm font-bold text-safety hover:text-[#d97c12] transition-colors"
                >
                  {p.domain} <ArrowUpRight size={14} />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap items-center gap-4" data-testid="product-access-links">
            <a
              href="https://wsafe.si"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="product-link-cctv"
              className="inline-flex items-center gap-1.5 text-sm font-bold text-safety hover:text-[#d97c12] transition-colors"
            >
              CCTV <ArrowUpRight size={14} />
            </a>
            <a
              href="https://wsafe.ai"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="product-link-mobile-app"
              className="inline-flex items-center gap-1.5 text-sm font-bold text-safety hover:text-[#d97c12] transition-colors"
            >
              Mobile app <ArrowUpRight size={14} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
